import { render } from "./IconError.vue?vue&type=template&id=6bdc779a"
import script from "./IconError.vue?vue&type=script&lang=js"
export * from "./IconError.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__